import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterWithdrawalRequests from 'views/agent/comissions/withdrawalRequests/filterWithdrawalRequest'; // Importing filter component for withdrawal requests
import TableWithdrawalRequest from 'views/agent/comissions/withdrawalRequests/tableWithdrawalRequest'; // Importing table component for withdrawal requests
import DetailsWithdrawalRequest from 'views/agent/comissions/withdrawalRequests/detailsWithdrawalRequests'; // Importing details component for withdrawal requests
import RecordWithdrawalRequest from 'views/agent/comissions/withdrawalRequests/recordWithdrawalRequest'; // Importing record component for withdrawal requests
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the withdrawal requests view.
 * @extends JetView
 */
export default class withdrawalRequestsView extends JetView {
    /**
     * Configures the layout of the withdrawal requests view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Right section layout configuration
        const right = {
            type: 'wide',
            minWidth: 400,
            rows: [
                PlayersView, // Including PlayersView in the right section
                RecordWithdrawalRequest, // Including record component in the right section
                DetailsWithdrawalRequest, // Including details component in the right section
            ],
        };

        // Toolbar configuration for pagination
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Template for pager buttons
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default size for data fetch from configuration
                },
            ],
        };

        // Left section layout configuration
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme, // Applying the current theme
                    elements: [
                        { view: 'label', label: _('Solicitudes de Retiro') }, // Label for withdrawal requests
                    ],
                },
                FilterWithdrawalRequests, // Including filter component in the left section
                TableWithdrawalRequest, // Including table component in the left section
                toolbar, // Including the pagination toolbar in the left section
            ],
        };

        // Main layout configuration for the view
        return {
            id: 'a5', // Unique identifier for the view
            type: 'clean', // Clean layout type
            view: 'form', // Form view type
            scroll: 'y', // Vertical scrolling enabled
            rows: [
                {
                    responsive: 'a5', // Responsive layout configuration
                    type: 'wide',
                    cols: [left, right], // Combining left and right sections
                },
            ],
        };
    }
}

// FILE DOCUMENTED
